<template>
    <v-app id="element-to-pdf" class="portrait">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="3" lg="3" style="background-color:#1271A6" class="pr-0 pt-0 pl-0" justify="center">
                <v-row justify="center">
                    <v-hover v-slot="{ hover }">
                        <v-card class="mx-auto" color="grey lighten-4">
                            <v-img :src="dFoto" max-height="200" max-width="170" @error="dFoto = require('@/assets/images/user1.jpg')">
                                <v-expand-transition>
                                    <v-card-text @click="dModalDocs.dialog=true" v-if="hover" class="transition-fast-in-fast-out blue text-center title white--text" style="height: 100%;">
                                        <div><v-icon dark>edit</v-icon></div>
                                        Clic Cambiar Foto
                                    </v-card-text>
                                </v-expand-transition>
                            </v-img>
                        </v-card>
                    </v-hover>
                </v-row>
                <v-card class="mt-0" style="background-color:#1271A6">
                    <v-card-text class="pb-0 pr-1 pl-2 pt-0">
                        <v-list two-line color="#1271A6" dark>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>person</v-icon></v-list-item-icon>
                                <v-list-item-content><h3>{{dPriPersonal.Personal}}</h3><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>credit_card</v-icon></v-list-item-icon>
                                <v-list-item-content><v-list-item-title>{{dPriPersonal.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>smartphone</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriPersonal.Telefono}}</span><v-list-item-subtitle>Celular</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item class="px-0" style="height:10px">
                                <v-list-item-icon  class='mr-1'><v-icon>email</v-icon></v-list-item-icon>
                                <v-list-item-content><span>{{dPriPersonal.Email}}</span><v-list-item-subtitle>Correo Personal</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
                <v-card class="mt-2" style="background-color:#1271A6">
                    <v-btn @click="fuPriPersonaMetaValueModalOpen()" text dark block><v-icon>add</v-icon> Agregar</v-btn>
                </v-card>
                <v-card class="mt-2" style="background-color:#1271A6">
                    <v-btn @click="fuPdf()" small text dark block><v-icon>file_download</v-icon> Descargar</v-btn>
                </v-card>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" style="background-color:#f5f5f5" class="pa-1">
                <v-card v-for="item in dPriPersonaMetaValues" :key="item.nombre" style="background-color:#f5f5f5">
                    <v-card-title class=" py-0" style="border-bottom:4pt solid #1271A6;">
                        <span class="title mb-1" style="color:#1271A6">{{item.nombre}}</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-timeline dense>
                            <v-timeline-item v-for="(item2, i) in item.items" :key="i" color="#1271A6" small class="pa-0">
                                <v-row>
                                    <v-col cols="2" class="pa-0">
                                        <strong>{{fuJson(item2.value, 0)}} - {{fuJson(item2.value, 1)}}</strong>
                                    </v-col>
                                    <v-col cols="9" class="pa-0">
                                        <h4 :class="`font-weight`" style="color:#1271A6">{{fuJson(item2.value, 2).toUpperCase()}}</h4>
                                        <div class="body-2">{{fuJson(item2.value, 3)}}</div>
                                        <div class="caption">{{fuJson(item2.value, 4)}}</div>
                                    </v-col>
                                    <v-col cols="1" class="pa-0">
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEdit(item2)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-title><v-btn @click="fuPriPersonaMetaValueEliminar(item2)" color="error" block dark><v-icon>delete</v-icon> Eliminar</v-btn></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>
                                </v-row>
                            </v-timeline-item>
                        </v-timeline>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dPriPersonaMetaValueModal.dialog" max-width="1000">
            <template>
                <v-form ref="refPriPersonaMetaValueModal">
                    <v-card :loading="dPriPersonaMetaValueModal.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">{{ dPriPersonaMetaValue.nombre }}</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuPriPersonaMetaValueSave()" style="color:#1271A6" :loading="dPriPersonaMetaValueModal.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dPriPersonaMetaValueModal.dialog = false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-row dense>
                                <v-col cols="12" xm="6" sm="4">
                                    <v-select v-model="dPriPersonaMetaValue.nombre" label="* Aspecto" :items="['Especializacion', 'Formacion', 'Idioma', 'Laboral']" filled prepend-inner-icon="event_note" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                </v-col>
                                <v-col cols="12" xm="6" sm="4">
                                    <v-autocomplete v-model="dPriPersonaMetaValue.inicio_at" label="* Año Inicio" :items="dYears" filled prepend-inner-icon="event_note" :rules="[v => !!v || 'El campo es requerido']"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xm="6" sm="4">
                                    <v-autocomplete v-model="dPriPersonaMetaValue.end_at" label="Año Fin" :items="dYears" filled prepend-inner-icon="event_note"></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-text-field v-model="dPriPersonaMetaValue.instituto" :label=cLabel3 prepend-inner-icon="account_balance" outlined dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="100" autocomplete="off"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-text-field v-model="dPriPersonaMetaValue.carrera" :label=cLabel4 prepend-inner-icon="bookmark" outlined dense :rules="[v => !!v || 'El campo es requerido']" :maxlength="100" autocomplete="off"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" xm="12" sm="12">
                                    <v-textarea v-model="dPriPersonaMetaValue.detalle" label="Detalle" outlined name="Detalle" rows="3"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
        <v-dialog v-model="dModalDocs.dialog" max-width="500">
            <template>
                <v-form ref="refModalDocs">
                    <v-card :loading="dModalDocs.IsUpdating">
                        <v-toolbar class="justify-end" color="#1271A6">
                            <span class="headline" style="color:white">CAMBIAR FOTO</span>
                            <v-spacer></v-spacer>
                            <v-btn @click="fuModalDocsSave()" style="color:#1271A6" :loading="dModalDocs.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                            <v-btn @click="dModalDocs.dialog=false" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text fluid>
                            <v-file-input v-model="dSelectedFile" label="Seleccionar Foto" filled accept=".jpg,image/jpeg" :rules="[v => !!v || 'El campo es requerido']"></v-file-input>
                        </v-card-text>
                    </v-card>
                </v-form>
            </template>
        </v-dialog>
    </v-app>
</template>
<script>
import html2pdf from 'html2pdf.js';
import gql from 'graphql-tag';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'AlumnoCVByAlumno',
    mounted(){
        if (this.$route.params.pDNI){
            this.fuLoad(parseInt(this.$route.params.pDNI));
            this.dFoto = this.getFoto(this.$route.params.pDNI);
        }
        let today = new Date();        
        for (var i = today.getFullYear(); i >= today.getFullYear()-80; i--) {
            this.dYears.push(i);
        }
    },
    data: () => ({
        dLoading: false,
        dFoto: '',
        dPriPersonal: {
            IdPersonal: '',
            Personal: '',
            DNI: '',
            Telefono: '',
            Email: '',
        },
        version: 1,
        dPriPersonaMetaValues: [],
        dPriPersonaMetaValue: {
            id: null,
            nombre: '',
            inicio_at: '',
            end_at: '',
            instituto: '',
            carrera: '',
            detalle: '',
        },
        dPriPersonaMetaValueDefault: {
            inicio_at: '',
            nombre: '',
            end_at: '',
            instituto: '',
            carrera: '',
            detalle: '',
        },
        dPriPersonaMetaValueModal: {
            title: '',
            dialog: false,
            IsUpdating: false,
        },
        dSelectedFile: null,
        dModalDocs: {
            dialog: false,
            IsUpdating: false,
        },
        dYears: [],
    }),
    computed: {
        cLabel3(){
            switch(this.dPriPersonaMetaValue.nombre){
                case "Formacion":
                case "Especializacion":
                case "Idioma":
                    return 'Institución / Universidad';
                    break;
                default: // case "Laboral":
                    return 'Empresa';
            }
        },
        cLabel4(){
            switch(this.dPriPersonaMetaValue.nombre){
                case "Formacion":
                    return 'Carrera';
                    break;
                case "Especializacion":
                    return 'Especialidad';
                    break;
                case "Idioma":
                    return 'Idioma / Nivel';
                    break;
                case "Laboral":
                    return 'Cargo';
                    break;
            }
        },
        cName3(){
            if(this.dPriPersonaMetaValue.nombre=='Formacion' || this.dPriPersonaMetaValue.nombre=='Especializacion')
                return 'instituto'
            return 'empresa'
        },
        cName4(){
            if(this.dPriPersonaMetaValue.nombre=='Formacion')
                return 'carrera'
            if(this.dPriPersonaMetaValue.nombre=='especializacion')
                return 'Especialidad'
            return 'cargo'
        },
    },
    methods: {
        reloadPage() {
            // Usamos window.location.reload() para recargar la página.
            window.location.reload();
        },
        async fuModalDocsSave(){
            if (!this.dSelectedFile) {
                Swal.fire('¡ ERROR !', 'Por favor selecciona una imagen.', 'error')
                return;
            }
            this.dModalDocs.IsUpdating = true;
            
            try {
                const formData = new FormData();
                formData.append('file', this.dSelectedFile);

                const consulta = await this.$apollo.mutate({
                    mutation: gql`mutation pripersonametaUploadImage($documento_identidad: String!, $file: Upload){
                        pripersonametaUploadImage(
                            documento_identidad: $documento_identidad,
                            file: $file,
                        ){
                            error
                        }
                    }`,
                    variables: {
                        documento_identidad: this.dPriPersonal.DNI,
                        file: this.dSelectedFile,
                    },
                    context: {
                        hasUpload: true
                    }
                });
                this.reloadPage();

                Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                this.dModalDocs.dialog = false;
            } catch (error) {
                console.error(error);
                Swal.fire('¡ ERROR !', 'Error al subir la imagen.', 'error')
            } finally {
                this.dModalDocs.IsUpdating = false;
            }
        },
        getFoto(dni) {
            const randomNumber = Math.random();
            return `https://academico.khipu.edu.pe/public/images/persona/${dni}.jpg?v=${randomNumber}`;
        },
        fuJson(vItem, vPosition) {
            let pItem = JSON.parse(vItem);
            if (pItem.length>=vPosition+1) {
                return pItem[vPosition].value;
            } else {
                return '';
            }
        },
        async fuLoad(pDNI) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($DNI: String!){
                            pripersonalByDNI(DNI: $DNI){
                                IdPersonal
                                Personal
                                DNI
                                Telefono
                                Email
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        DNI: pDNI
                    }
                })
                this.dPriPersonal.IdPersonal = response.data.pripersonalByDNI.IdPersonal;
                this.dPriPersonal.Personal = response.data.pripersonalByDNI.Personal;
                this.dPriPersonal.DNI = response.data.pripersonalByDNI.DNI;
                this.dPriPersonal.Telefono = response.data.pripersonalByDNI.Telefono;
                this.dPriPersonal.Email = response.data.pripersonalByDNI.Email;
                this.fupripersonametavalueBydocumento_identidad(pDNI);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        async fupripersonametavalueBydocumento_identidad(pdocumento_identidad) {
            this.dPriPersonaMetaValues = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query pripersonametavalueBydocumento_identidad($documento_identidad: String!){
                        pripersonametavalueBydocumento_identidad(documento_identidad: $documento_identidad){
                            id
                            nombre
                            value
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        documento_identidad: pdocumento_identidad
                    }
                });
                const result = response.data.pripersonametavalueBydocumento_identidad.sort((a, b) => a.nombre.localeCompare(b.nombre));
                
                const agrupadoPorNombre  = result.reduce((acc, item) => {
                    if (!acc[item.nombre]) {
                        acc[item.nombre] = [];
                    }
                    acc[item.nombre].push(item);
                    return acc;
                }, {});

                this.dPriPersonaMetaValues = Object.entries(agrupadoPorNombre ).map(([nombre, items]) => ({
                    nombre,
                    items
                }));
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        async fuPriPersonaMetaValueUpdate (vValue) {
            try {
                this.dPriPersonaMetaValueModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation pripersonametavalueUpdate($id: ID!, $value: [IsObject]){
                        pripersonametavalueUpdate(id:$id, value: $value){
                            success
                        }
                    }`,
                    variables: {
                        id: this.dPriPersonaMetaValue.id,
                        value: vValue,
                    }
                });
                this.fuLoad(this.dPriPersonal.DNI);
                Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                this.dPriPersonaMetaValueModal.dialog = false;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dPriPersonaMetaValueModal.IsUpdating = false;
            }
        },
        fuPriPersonaMetaValueEliminar(item){
            Swal.fire({
                icon: 'question',
                title: 'Confirmación',
                html: '¿Esta seguro de Eliminar?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.$apollo.mutate({
                        mutation: gql`mutation pripersonametavalueDelete($id: ID!){
                            pripersonametavalueDelete(id: $id){
                                id
                            }
                        }`,
                        variables: {
                            id: item.id
                        }
                    });
                },
            }).then((result) => {
                this.fuLoad(this.dPriPersonal.DNI);
            })
        },
        async fuPriPersonaMetaValueEdit(item){
            this.dPriPersonaMetaValue = Object.assign({}, this.dPriPersonaMetaValueDefault);
            this.dPriPersonaMetaValue.nombre=item.nombre;
            this.dPriPersonaMetaValue.id = item.id;
            this.dPriPersonaMetaValue.inicio_at = JSON.parse(item.value)[0].value;
            this.dPriPersonaMetaValue.end_at = JSON.parse(item.value)[1].value;
            this.dPriPersonaMetaValue.instituto = JSON.parse(item.value)[2].value;
            this.dPriPersonaMetaValue.carrera = JSON.parse(item.value)[3].value;
            if (JSON.parse(item.value).length>=5)
                this.dPriPersonaMetaValue.detalle = JSON.parse(item.value)[4].value;
            else
                this.dPriPersonaMetaValue.detalle = '';

            this.dPriPersonaMetaValueModal.dialog = true;
        },
        fuPriPersonaMetaValueModalOpen(){
            this.dPriPersonaMetaValue = Object.assign({}, this.dPriPersonaMetaValueDefault);
            this.dPriPersonaMetaValue.nombre="";
            this.dPriPersonaMetaValueModal.dialog = true;
            this.dPriPersonaMetaValue.id = null;
        },
        fuPriPersonaMetaValueSave(){
            if(this.$refs.refPriPersonaMetaValueModal.validate()){
                let vValue = [
                    {type: 'year', name: 'inicio_at', label: 'Año de Inicio', value: this.dPriPersonaMetaValue.inicio_at, class: 'col-span-2'},
                    {type: 'year', name: 'end_at', label: 'Año de Termino', value: this.dPriPersonaMetaValue.end_at, class: 'col-span-2'},
                    {type: 'text', name: this.cName3, label: this.cLabel3, value: this.dPriPersonaMetaValue.instituto, class: 'col-span-8'},
                    {type: 'text', name: this.cName4, label: this.cLabel4, value: this.dPriPersonaMetaValue.carrera, class: 'col-span-10'},
                    {type: 'text', name: 'detalle', label: 'Detalle', value: this.dPriPersonaMetaValue.detalle, class: 'col-span-10'},
                ];

                if(!this.dPriPersonaMetaValue.id)
                    this.fuPriPersonaMetaValueCreate(vValue);
                else
                    this.fuPriPersonaMetaValueUpdate(vValue);
            }
        },
        async fuPriPersonaMetaValueCreate (vValue) {
            try {
                this.dPriPersonaMetaValueModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation pripersonametavalueCreate($nombre: String, $value: [IsObject], $documento_identidad: String!){
                        pripersonametavalueCreate(nombre:$nombre, value: $value, documento_identidad: $documento_identidad){
                            success
                        }
                    }`,
                    variables: {
                        nombre: this.dPriPersonaMetaValue.nombre,
                        value: vValue,
                        documento_identidad: this.dPriPersonal.DNI,
                    }
                });
                this.fuLoad(this.dPriPersonal.DNI);
                Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                this.dPriPersonaMetaValueModal.dialog = false;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dPriPersonaMetaValueModal.IsUpdating = false;
            }
        },
        async fuPriPersonaMetaValueUpdate (vValue) {
            try {
                this.dPriPersonaMetaValueModal.IsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation pripersonametavalueUpdate($id: ID!, $value: [IsObject]){
                        pripersonametavalueUpdate(id:$id, value: $value){
                            success
                        }
                    }`,
                    variables: {
                        id: this.dPriPersonaMetaValue.id,
                        value: vValue,
                    }
                });
                Swal.fire('Correcto', 'Se guardó correctamente', 'success');
                this.dPriPersonaMetaValueModal.dialog = false;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dPriPersonaMetaValueModal.IsUpdating = false;
            }
        },
        fuPdf(){
            var element = document.getElementById('element-to-pdf');
            var opt = {
                margin: 0,
                filename: this.dPriPersonal.DNI+'.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 3 },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                useCORS: true
            };
            html2pdf().from(element).set(opt).save();
        },
        fImage(url) {
            const endPoint = 'https://apigraphql.khipu.edu.pe/graphql/'
            const query = `
            query {
                downloadImageAsBase64(url: "https://proxy.khipu.edu.pe/${url}")
            }`;

            fetch(endPoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: query
                })
            }).then(response => response.json())
            .then(data => {
                this.dFoto = 'data:image/png;base64,' +  data.data.downloadImageAsBase64;
            })
        }
    }
}
</script>
<style scoped>
    .portrait {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
    }
</style>